<div class="content-wrapper">
    <div class="container-xxl flex-grow-1 container-p-y">
        <h4 class="fw-bold py-3 " style="font-size: 17px;margin-left:20px; margin-top: 0.5cm;"><span
                class="text-muted fw-light">Business
                Profile /</span> Company Details</h4>

        <mat-card class="card">
            <mat-card-header class="mt-3">
                <mat-icon>apartment</mat-icon>Company Details
            </mat-card-header>

            <hr class="my-0 mt-3 mb-2" />

            <mat-card-content>
                <form [formGroup]="companyDetailsForm" (ngSubmit)="onSubmit()">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="adminControls">
                                <mat-form-field appearance="outline">
                                    <mat-label>Company Name</mat-label>
                                    <input matInput formControlName="CompanyName"
                                        [ngClass]="{'is-invalid':submitted && forms.CompanyName.errors}" required>
                                    <mat-error *ngIf="submitted && forms.CompanyName.errors" class="invalid-feedback">
                                        <div *ngIf="forms.CompanyName.errors.required"> This field is required </div>
                                    </mat-error>
                                </mat-form-field>

                                <mat-form-field appearance="outline" id="byid">
                                    <mat-label>Company Registration Number</mat-label>
                                    <input matInput formControlName="CompanyRegistrationNumber" readonly="true"
                                        (keypress)="numberOnly($event)">
                                </mat-form-field>

                                <mat-form-field appearance="outline">
                                    <mat-label>Zip Code</mat-label>
                                    <input matInput formControlName="ZipCode" (keypress)="numberOnly($event)"
                                        (input)="onZipCodeChange($event)">
                                    <mat-error *ngIf="submitted && forms.ZipCode.errors" class="invalid-feedback">
                                        <!-- <div *ngIf="forms.ZipCode.errors.required"> This field is required </div> -->
                                        <!-- <div *ngIf="forms.ZipCode.errors.minlength">Mininmum length is 5</div> -->
                                        <div *ngIf="forms.ZipCode.errors.maxlength">Maximum length is 5</div>
                                    </mat-error>
                                </mat-form-field>

                                <mat-form-field appearance="outline">
                                    <mat-label>State</mat-label>
                                    <!-- <input matInput formControlName="State" (keypress)="numberOnly($event)"> -->
                                    <mat-select formControlName="State" name="State" id="State">
                                        <mat-option *ngFor="let State of states" [value]="State">
                                            {{ State }}
                                        </mat-option>
                                    </mat-select> 
                                    <!-- <mat-error *ngIf="submitted && forms.State.errors" class="invalid-feedback">
                                        <div *ngIf="forms.State.errors.required"> This field is required </div>
                                    </mat-error> -->
                                </mat-form-field>

                                <!-- <mat-form-field appearance="outline">
                                    <mat-label>Country</mat-label>
                                    <input matInput formControlName="Country"
                                        [ngClass]="{'is-invalid':submitted && forms.Country.errors}" required>
                                    <mat-error *ngIf="submitted && forms.Country.errors" class="invalid-feedback">
                                        <div *ngIf="forms.Country.errors.required"> This field is required </div>
                                    </mat-error>
                                </mat-form-field> -->

                                <!-- <mat-form-field appearance="outline">
                                    <mat-label>Country</mat-label>
                                    <input matInput formControlName="Country" name="Country" id="Country" required
                                        [ngClass]="{'is-invalid':submitted && forms.Country.errors}" autofocus>
                                    <select matNativeControl id="Country" formControlName="Country" name="Country"
                                        [ngClass]="{'is-invalid':submitted && forms.Country.errors}" required>
                                        <option value="">Select</option>
                                        <option value="Australia">Australia</option>
                                        <option value="Bangladesh">Bangladesh</option>
                                        <option value="China">China</option>
                                        <option value="France">France</option>
                                        <option value="Germany">Germany</option>
                                        <option value="India">India</option>
                                        <option value="Mexico">Mexico</option>
                                        <option value="Philippines">Philippines</option>
                                        <option value="Russia">Russian Federation</option>
                                        <option value="South Africa">South Africa</option>
                                        <option value="Thailand">Thailand</option>
                                        <option value="Turkey">Turkey</option>
                                        <option value="Ukraine">Ukraine</option>
                                        <option value="United Arab Emirates">United Arab Emirates</option>
                                        <option value="United Kingdom">United Kingdom</option>
                                        <option value="United States">United States</option>
                                    </select>
                                    <mat-error *ngIf="submitted && forms.Country.errors" class="invalid-feedback">
                                        <div *ngIf="forms.Country.errors.required">Country is required</div>
                                    </mat-error>
                                </mat-form-field> -->
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="adminControls">
                                <mat-form-field appearance="outline">
                                    <mat-label>Nature of Business</mat-label>
                                    <input matInput formControlName="NatureOfBusiness">
                                    <!-- [ngClass]="{'is-invalid':submitted && forms.NatureOfBusiness.errors}">
                                    <mat-error *ngIf="submitted && forms.NatureOfBusiness.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="forms.NatureOfBusiness.errors.required"> This field is required
                                        </div>
                                    </mat-error> -->
                                </mat-form-field>

                                <mat-form-field appearance="outline" id="byid">
                                    <mat-label>Tax ID Number</mat-label>
                                    <input matInput formControlName="TaxIdNumber" readonly="true">
                                </mat-form-field>

                                <!-- <mat-form-field appearance="outline" style="visibility: hidden;">
                                    <mat-label>District</mat-label>
                                    <input matInput formControlName="District"
                                        [ngClass]="{'is-invalid':submitted && forms.District.errors}" required>
                                    <mat-error *ngIf="submitted && forms.District.errors" class="invalid-feedback">
                                        <div *ngIf="forms.District.errors.required"> This field is required </div>
                                    </mat-error>
                                </mat-form-field> -->

                                <mat-form-field appearance="outline">
                                    <mat-label>Address</mat-label>
                                    <input matInput formControlName="Address">
                                    <!-- [ngClass]="{'is-invalid':submitted && forms.Address.errors}" required>
                                    <mat-error *ngIf="submitted && forms.Address.errors" class="invalid-feedback">
                                        <div *ngIf="forms.Address.errors.required"> This field is required </div>
                                    </mat-error> -->
                                </mat-form-field>

                                <mat-form-field appearance="outline">
                                    <mat-label>City </mat-label>
                                    <!-- <input matInput formControlName="City"> -->
                                    <mat-select formControlName="City" name="City" id="City">
                                        <mat-option *ngFor="let City of cities" [value]="City">
                                            {{ City }}
                                        </mat-option>
                                    </mat-select>
                                    <!-- <mat-error *ngIf="submitted && forms.City.errors" class="invalid-feedback">
                                        <div *ngIf="forms.City.errors.required"> This field is required </div>
                                    </mat-error> -->
                                </mat-form-field>

                            </div>
                        </div>
                    </div>
                    <alert></alert>
                    <mat-card-actions>
                        <div class="buttonRow">
                            <button class="buttonColor" mat-raised-button type="submit">Save</button>
                            <!-- <button mat-raised-button color="primary"
                                [routerLink]="'/All/updateCompany'">Update</button> -->

                        </div>
                    </mat-card-actions>
                </form>
            </mat-card-content>
        </mat-card>
    </div>
</div>